export const Help = {
  Label: (entity: string) =>
    `Human readable text to display instead of the URL in the External Links column for the ${entity}` as const,
  Reference:
    'A URL to give the Quick Link. Can be left blank to allow for custom URLs when adding Quick Links',
  Description:
    'A longer description to help describe this Quick Link in the External Links Editor',
} as const
